import React, {
    Component,
    useState
} from 'react'
import {
    Nav,
    NavLink,
    Link,
} from 'react-router-dom'
import { actionTypes } from '~/constants';
import Icon from '@material-ui/core/Icon';
import Alert from '@material-ui/lab/Alert';
import AlertTitle from '@material-ui/lab/AlertTitle';

import fetch from '~/utils/fetch';

import LinkButton from '~/widgets/button-link'
import XInput from '~/widgets/x-input';
import XDate from '~/widgets/x-date';
import XSwitch from '~/widgets/x-switch';

const ROLE_TYPES = ['First Responder', 'Maintenance'].map(x=>({label: x, value: x}));

class Container extends Component {
    constructor() {
        super()
        this.state = {
            error: null,
            is_loaded: false,
            is_editing: false,
            user: {
                onboardingEmailSent: true,
                autoSendReportsVCA: true,
                active: true,
                acceptedTos: false,
                acceptedPrivacy: false,
                vcaInternalRep: '',
            },
        }
    }

    async componentDidMount() {
        this.props.dispatch({type: actionTypes.USERS_CLEAR_DETAIL})
        if(this.props.match.params.user_id){
            this.props.dispatch({type: actionTypes.USERS_FETCH_ONE, id: this.props.match.params.user_id})
        }else{
            this.setState({
                user: {
                    ...this.state.user,
                    clientId: this.props.match.params.department_id,
                },
                is_loaded: true
            })
        }
    }

    bindState(path, value, third) {
        const newState = Object.assign({}, this.state);
        _.set(newState, path, value);
        this.setState(newState);
    }

    componentDidUpdate(prevProps, prevState) {
        if(this.props.users.is_loaded && prevProps.users.is_loaded !== this.props.users.is_loaded){
            this.setState({
                is_loaded: true,
                user: {
                    ...this.state.user,
                    ...this.props.users.detail
                }
            })
        }
    }

    handleSubmit(e) {
        e.preventDefault();
        if(this.props.users.detail !== null){
            // editing
            this.props.dispatch({
                type: actionTypes.USERS_UPDATE_ONE,
                id: this.props.users.detail._id,
                data: {
                    ...this.props.users.detail,
                    ...this.state.user
                }
            });
        }else{
            // creating
            this.props.dispatch({
                type: actionTypes.USERS_CREATE_ONE,
                data: {
                    ...this.state.user
                }
            });
        }
    }

    render() {
        console.log(this.props);
        console.log(this.state);

        if(!this.state.is_loaded){
            return 'Loading...'  // hide while loading
        }

        return (
            <form onSubmit={this.handleSubmit.bind(this)}> {/* parent is div.page */}
                <div className="page-nav">
                    <div className="breadcrumb">
                        <LinkButton to={`/app/departments/${this.props.match.params.department_id || ''}`} className="button button-clear">
                            <Icon>arrow_back</Icon>&nbsp;&nbsp;Return
                        </LinkButton>
                    </div>
                    <div className="page-actions">
                        <LinkButton className="button button-secondary button-wide" type="submit">
                            <Icon>save</Icon>&nbsp;&nbsp;Save User
                        </LinkButton>
                    </div>
                </div>
                <div className="card">
                    {this.props.users.detail ? (
                        <div className="card-heading">
                            <div className="card-heading-action">
                                Editing
                            </div>
                            <div className="card-heading-arrow">
                                <Icon>arrow_forward</Icon>
                            </div>
                            <div className="card-heading-text">
                                {this.props.users.detail.firstname}
                                &nbsp;
                                {this.props.users.detail.lastname}
                            </div>
                        </div>
                    ) : (
                        <div className="card-heading">
                            <div className="card-heading-action">
                                Create
                            </div>
                            <div className="card-heading-arrow">
                                <Icon>arrow_forward</Icon>
                            </div>
                            <div className="card-heading-text">
                                New User
                            </div>
                        </div>
                    )}
                    <div className="card-content">
                        <div className="form-sections">
                            <div className="form-section">
                                <div className="form-row">
                                    <XInput
                                        label="First Name"
                                        required={true}
                                        name='firstname'
                                        handleChange={this.bindState.bind(this, 'user.firstname')}
                                        value={this.state.user.firstname}
                                    />
                                    <XInput
                                        label="Middle Initial"
                                        name='middleInitial'
                                        handleChange={this.bindState.bind(this, 'user.middleInitial')}
                                        value={this.state.user.middleInitial}
                                        style={{maxWidth: '110px'}}
                                    />
                                    <XInput
                                        label="Last Name"
                                        required={true}
                                        name='lastname'
                                        handleChange={this.bindState.bind(this, 'user.lastname')}
                                        value={this.state.user.lastname}
                                    />
                                </div>
                                <div className="form-row">
                                    <XInput
                                        label="Email"
                                        required={true}
                                        name='email'
                                        handleChange={this.bindState.bind(this, 'user.email')}
                                        value={this.state.user.email}
                                        helperText={this.props.users.detail ? `Email can't be changed.` : `This will be the user's login. Email can't be changed.`}
                                        disabled={Boolean(this.props.users.detail)}
                                    />
                                </div>
                                {this.props.users.detail ? null : (
                                    <React.Fragment>
                                        <div className="form-row" style={{marginTop: '2rem'}}>
                                            <Alert severity="info">
                                                <AlertTitle>Random Password</AlertTitle>
                                                A temporary password will be created and emailed to the user. The user will be asked to set a new password upon logging in for the first time.
                                            </Alert>
                                        </div>
                                        <div className="form-row">
                                            <XSwitch
                                                label="Send New Account Email"
                                                name="onboardingEmailSent"
                                                value={this.state.user.onboardingEmailSent}
                                                handleChange={this.bindState.bind(this, 'user.onboardingEmailSent')}
                                            />
                                        </div>
                                    </React.Fragment>
                                )}
                                <div className="form-row">
                                    <XInput
                                        label="Primary Phone"
                                        required={true}
                                        name='phone'
                                        handleChange={this.bindState.bind(this, 'user.phone')}
                                        value={this.state.user.phone}
                                    />
                                </div>
                                <div className="form-row">
                                    <XInput
                                        label="Secondary Phone"
                                        required={false}
                                        name='mobile'
                                        handleChange={this.bindState.bind(this, 'user.mobile')}
                                        value={this.state.user.mobile}
                                    />
                                </div>
                                <div className="form-row">
                                    <XInput
                                        label="Badge #"
                                        required={false}
                                        name='badgeNumber'
                                        handleChange={this.bindState.bind(this, 'user.badgeNumber')}
                                        value={this.state.user.badgeNumber}
                                    />
                                    <XInput
                                        label="Role"
                                        required={true}
                                        name='role'
                                        handleChange={this.bindState.bind(this, 'user.role')}
                                        value={this.state.user.role}
                                        choices={ROLE_TYPES}
                                    />
                                </div>
                                <div className="form-row">
                                    <XInput
                                        label="VCA Rep. PID # (Optional)"
                                        required={false}
                                        disabled={!!this.props.users.detail}
                                        type='number'
                                        name='vcaInternalRep'
                                        handleChange={this.bindState.bind(this, 'user.vcaInternalRep')}
                                        value={this.state.user.vcaInternalRep}
                                    />
                                </div>
                                <div className="form-row">
                                    <XInput
                                        label="Notes"
                                        required={false}
                                        multiline={true}
                                        rows={5}
                                        name='notes'
                                        handleChange={this.bindState.bind(this, 'user.notes')}
                                        value={this.state.user.notes}
                                    />
                                </div>
                                <div className="form-row form-row-wrap">
                                    <XDate
                                        label="Created At"
                                        value={this.state.user.createdAt}
                                    />
                                    <XDate
                                        label="Updated At"
                                        value={this.state.user.updatedAt}
                                    />
                                </div>
                                <div className="form-row">
                                    <XSwitch
                                        label="Auto-send Reports to VCA"
                                        name="autoSendReportsVCA"
                                        value={this.state.user.autoSendReportsVCA}
                                        handleChange={this.bindState.bind(this, 'user.autoSendReportsVCA')}
                                    />
                                </div>
                                <div className="form-row">
                                    <XSwitch
                                        label="User Active"
                                        name="active"
                                        value={this.state.user.active}
                                        handleChange={this.bindState.bind(this, 'user.active')}
                                        disabled={this.props.users.detail ? false : true}
                                    />
                                </div>
                                <div className="form-row">
                                    <XSwitch
                                        label="Accepted Terms of Service"
                                        name="acceptedTos"
                                        value={this.state.user.acceptedTos}
                                        handleChange={this.bindState.bind(this, 'user.acceptedTos')}
                                        disabled={true}
                                    />
                                </div>
                                <div className="form-row">
                                    <XSwitch
                                        label="Accepted Privacy Policy"
                                        name="acceptedPrivacy"
                                        value={this.state.user.acceptedPrivacy}
                                        handleChange={this.bindState.bind(this, 'user.acceptedPrivacy')}
                                        disabled={true}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </form>
        )
    }
}

import { connect } from 'react-redux'
export default connect(
    (state)=>{
        return {
            users: state.users,
        }
    },
    (dispatch)=>{
        return {
            dispatch: dispatch
        }
    },
    null,
    {pure: false}
)(Container);